module.exports = __webpack_public_path__ + "img/check-white.5eccf4da.svg";